import React, { useState, useEffect, Fragment } from 'react';

import { Grid, TextField, Button, CircularProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import useStyles from './IMAdjustmenForm.styles';
import useProductsIM from 'hooks/useProductsIM';
import productImage from 'assets/img/productDefault.png';
import Skeleton from '@material-ui/lab/Skeleton';
import { AJUSTE } from 'constants/constBd';
import useMovementsIM from 'hooks/useMovementsIM';
import { FormEntry } from 'interfaces/imInventoryMovements.interface';
import { IGaleryImages } from 'interfaces/imProducts.interface';
interface Props {
  productId: number;
  parentId: number;
  handleCloseModal(): void;
  getAllProducts(): void;
}

export default function IMAdjustmentForm({ productId, parentId, getAllProducts, handleCloseModal }: Props) {
  const { getProductById } = useProductsIM();
  const { showNotistack } = useCustomSnackbar();
  const { createMovement } = useMovementsIM();

  const { handleSubmit, register, errors, reset } = useForm<FormEntry>();
  const [productDetail, setProductDetail] = useState({
    sku: '',
    name: ''
  });

  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [galeryImagesProduct, setGaleryImagesProduct] = useState<IGaleryImages[]>([]);

  const getProduct = () => {
    setIsLoading(true);
    getProductById(String(productId))
      .then((resultProduct: any) => {
        setGaleryImagesProduct(resultProduct.galeryImages);
        setProductDetail({ name: resultProduct.name, sku: resultProduct.sku });
        reset(resultProduct);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getProduct();
  }, []);

  const onSubmit = (data: FormEntry) => {
    data.stock = Number(data.stock);
    const document = {
      remission: '',
      invoice: '',
      purchaseOrder: '',
      order: '',
      guide: '',
      observations: '',
      documentTypeId: AJUSTE
    };

    const dataToSend = [
      {
        document: document,
        products: [{ parentId: parentId, productId: productId, unitCost: 0, quantity: data.stock }]
      }
    ];

    setIsLoading(true);
    createMovement(dataToSend)
      .then((response: boolean) => {
        if (response === true) {
          showNotistack({ message: 'El ajuste se guardó correctamente' });
          getAllProducts();
          handleCloseModal();
        } else {
          showNotistack({ message: 'Ocurrió un error' });
        }
      })
      .catch((err: any) => {
        console.log(err.reponse?.data);
        showNotistack({ message: 'Ocurrió un error' });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const imageProduct = (url: string, key: string) => {
    return <img src={url} key={key} alt="productImage" height="90px" width="90px" className={classes.containerImage} />;
  };

  return (
    <form noValidate onSubmit={handleSubmit(onSubmit)}>
      <Grid container direction="row" spacing={2} justify="center">
        <Grid item xs={12} sm={12} md={12}>
          <Grid container justify="space-around">
            <Grid item xs={4}>
              {isLoading ? (
                <Grid container justify="center" style={{ marginTop: 15 }}>
                  <Skeleton variant="rect" width="90px" height="60px" />
                </Grid>
              ) : (
                <Fragment>
                  {galeryImagesProduct.map((image: any, index: number) => (
                    <Fragment key={`${image.url}${index}`}>
                      {image.main ? (
                        <Fragment>
                          {image.url ? imageProduct(image.url, image.url) : imageProduct(productImage, image.url)}
                        </Fragment>
                      ) : null}
                    </Fragment>
                  ))}
                </Fragment>
              )}
            </Grid>
            <Grid item xs={8}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                label="Producto"
                value={productDetail.name}
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
          <Grid container justify="space-around" spacing={2} direction="row">
            <Grid item xs={6}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="sku"
                label="SKU"
                value={productDetail.sku}
                autoComplete="sku"
                disabled={true}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                required
                variant="outlined"
                margin="normal"
                fullWidth
                name="stock"
                label="Cantidad"
                disabled={isLoading}
                inputRef={register<HTMLInputElement>({
                  required: 'Este campo es requerido',
                  pattern: {
                    value: /^[0-9\b]+$/,
                    message: 'Cantidad mínima invalida'
                  }
                })}
                error={errors.stock ? true : false}
                helperText={errors.stock && errors.stock.message}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
          <Grid container justify="center">
            <Button type="submit" variant="contained" color="primary" disabled={isLoading} style={{ marginTop: 10 }}>
              {isLoading ? <CircularProgress size={24} /> : ''} Guardar
            </Button>
            <Button
              variant="contained"
              color="default"
              disabled={isLoading}
              style={{ marginTop: 10, marginLeft: 20 }}
              onClick={handleCloseModal}
            >
              {isLoading ? <CircularProgress size={24} /> : ''} Cancelar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
